module.exports = __webpack_public_path__ + "img/vector_bottom.0121eac4.svg";